export default "__VITE_ASSET__DbdAM9bd__";